module.exports = __webpack_public_path__ + "img/certificate04-4.f17e0619.jpg";